import React from 'react';
import { ExperienceCard,EducationCard, ProfessionalSkills} from '../../Components';
import { useResume } from '../../data/dataCtx';

const Resume = ()=> {
    const resume = useResume();

    return (
        <main class="flex-shrink-0">
            <div class="container px-5 my-5">
                <div class="text-center mb-5">
                    <h1 class="display-5 fw-bolder mb-0"><span class="text-gradient d-inline">Resume</span></h1>
                </div>
                <div class="row gx-5 justify-content-center">
                    <div class="col-lg-11 col-xl-9 col-xxl-8">
                          <ExperienceCard downloadUrl={resume.main?.resumedownload} experience={resume.resume?.work} />
                        <EducationCard education={resume.resume?.education}/>
                        <div class="pb-5"></div>
                        <ProfessionalSkills resume={resume.resume ?? {}}/>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default Resume;